/*
 * サブシステム名：
 * 機能名：日報一覧
 * 表示項目カスタマイズ(antz)
 */
import D2PRMD0011 from '@/views/PRM/D2PRMD0011.js'
import DdCustomButton from '@/components/DdCustomButton'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'

export default {
  extends: D2PRMD0011,
  name: 'NippoListCustomForAntz',
  components: {
    DdCustomButton
  },
  data: () => ({
    custoMizeHeaders: [
      { text: '編集', value: 'actions', sortable: false, width: '20px' },
      { text: '運行日', value: 'unkoYmdDisp' },
      { text: '乗務員', value: 'jomuinJininNmSei' },
      { text: '傭車先', value: 'hacchusakiNm' },
      { text: '自動車表示名', value: 'jidoshaHyojiNm' },
      { text: '車種', value: 'sharyoShashuSbt' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '発時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着時刻', value: 'chakuchiHmsDisp' },
      { text: '走行距離', value: 'yoteiSokoKyoriDisp' },
      { text: '現場名', value: 'hinmeiDisp' },
      { text: '単価', value: 'tankaDisp' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
      { text: '高速代', value: 'hiwayPriceDisp', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingakuDisp', align: 'end' },
      { text: 'その他課税', value: 'unchinHokaKingakuDisp', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazeiDisp', align: 'end' },
      { text: '売上金額', value: 'uriageKingakuDisp', align: 'end' },
      { text: '支払計上日', value: 'shiharaiYoteiYmdDisp' },
      { text: '支払運賃', value: 'yoshaKihonUnchinDisp', align: 'end' },
      { text: '支払高速代', value: 'yoshaHiwayPriceDisp', align: 'end' },
      { text: '支払その他課税', value: 'yoshaUnchinHokaKingakuDisp', align: 'end' },
      { text: '支払その他非課税', value: 'yoshaUnchinHokaHikazeiDisp', align: 'end' },
      { text: '運行実績No', value: 'unkoJissekiNo' },
      { text: '受注No', value: 'juchuNo' },
      { text: '配車営業所', value: 'haishaEigyoshoNm' },
      { text: '売上営業所', value: 'juchuEigyoshoNm' },
      { text: '#', value: 'meisaiOrder' }
    ],
    tmpCustomSearchText: '',
    customSearchText: '',
    // 検索条件
    conditions: {
      unkoYoteiStartYmdString: null,
      unkoYoteiEndYmdString: null,
      haishaEigyoshoId: null,
      tokuisakiId: null,
      hacchusakiId: null,
      jomuinJininId: null,
      sharyoId: null,
      meisaiHeadFlg: false,
      customSearchText: ''
    },
    conditionDetails: [
      { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'tokuisakiId', name: '荷主', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'hacchusakiId', name: '傭車先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'jomuinJininId', name: '乗務員', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'sharyoId', name: '車両', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstsharyo' },
      { key: 'meisaiHeadFlg', name: '先頭の受注のみ表示', value: null, type: 'checkbox', delete: true, showValue: false, convertValue: false },
      { key: 'juchuEigyoshoId', name: '売上営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'customSearchText', name: '絞り込み', value: 'customSearchText', type: 'value', delete: true, showValue: true, convertValue: false }
    ]
  }),
  computed: {
    custoMizeFilteredRows () {
      console.log('filter', this.rows)
      const keyword = (this.conditions.customSearchText ?? '').toString().toLowerCase()
      return this.rows.filter(row => {
        // 検索文字列未指定なら全件
        if (!keyword) return true

        return Object.values(row).some(value => {
          if (value === null || value === undefined) return false

          return String(value)
            .toLowerCase()
            .includes(keyword)
        })
      }).map((elem) => {
        elem.juchuJissekiId = String(elem.keikakujissekikey) + String(elem.juchuNo)
        elem.unkoYmdDisp = elem.unkoYmd ? filter.dateFormatter(elem.unkoYmd) : ''
        // elem.keikakuKakuteiFlgDisp = elem.keikakuKakuteiFlg ? '〇' : ''
        // elem.jissekiTorokuKbnDisp = elem.trUnkoJissekiId > 0 ? '〇' : ''
        // elem.jissekiKakuninZumiFlgDisp = elem.jissekiKakuninZumiFlg ? '〇' : ''
        elem.haishaEigyoshoDisp = elem.haishaEigyoshoCd ? elem.haishaEigyoshoCd + ' : ' + elem.haishaEigyoshoNm : ''
        elem.haishaTantoshaDisp = elem.haishaTantoJininCd ? elem.haishaTantoJininCd + ' : ' + elem.haishaTantoJininNm : ''
        elem.hacchusakiDisp = elem.hacchusakiCd ? elem.hacchusakiCd + ' : ' + elem.hacchusakiNm : ''
        elem.sharyoDisp = elem.haishaKbn === '03' ? elem.torokuNo : elem.jidoshaHyojiNm
        elem.jomuinDisp = elem.jomuinJininCd ? elem.jomuinJininCd + ' : ' + elem.jomuinJininNmSei : ''
        elem.dojoshaDisp = elem.joshuJininCd ? elem.joshuJininCd + ' : ' + elem.joshuJininNmSei : ''
        elem.juchuEigyoshoDisp = elem.juchuEigyoshoCd ? elem.juchuEigyoshoCd + ' : ' + elem.juchuEigyoshoNm : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        // elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '〇' : ''
        // elem.seikyuTomeFlgDisp = elem.seikyuTomeFlg ? '〇' : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        // elem.keiyuchi1Disp = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiId1Biko
        // elem.keiyuchi2Disp = elem.keiyuchi2Cd ? elem.keiyuchi2Cd + ' : ' + elem.keiyuchi2Nm : elem.keiyuchiId2Biko
        // elem.keiyuchi3Disp = elem.keiyuchi3Cd ? elem.keiyuchi3Cd + ' : ' + elem.keiyuchi3Nm : elem.keiyuchiId3Biko
        // elem.keiyuchi4Disp = elem.keiyuchi4Cd ? elem.keiyuchi4Cd + ' : ' + elem.keiyuchi4Nm : elem.keiyuchiId4Biko
        // elem.keiyuchi5Disp = elem.keiyuchi5Cd ? elem.keiyuchi5Cd + ' : ' + elem.keiyuchi5Nm : elem.keiyuchiId5Biko
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        // elem.juchuSuryoDisp = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.tankaDisp = elem.tanka ? filter.numericFormatter(elem.tanka) : 0
        // elem.juchuJuryoDisp = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.kihonUnchinDisp = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : 0
        // elem.hokanKingakuDisp = elem.hokanKingaku ? filter.numericFormatter(elem.hokanKingaku) : 0
        // elem.niekiKingakuDisp = elem.niekiKingaku ? filter.numericFormatter(elem.niekiKingaku) : 0
        elem.taikiJikanKingakuDisp = elem.taikiJikanKingaku ? filter.numericFormatter(elem.taikiJikanKingaku) : 0
        elem.unchinHokaKingakuDisp = elem.unchinHokaKingaku ? filter.numericFormatter(elem.unchinHokaKingaku) : 0
        elem.hiwayPriceDisp = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : 0
        elem.unchinHokaHikazeiDisp = elem.unchinHokaHikazei ? filter.numericFormatter(elem.unchinHokaHikazei) : 0
        // elem.tatekaekinHikazeiDisp = elem.tatekaekinHikazei ? filter.numericFormatter(elem.tatekaekinHikazei) : 0
        // elem.jikanWarimashiKingakuDisp = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : 0
        // elem.kyoriWarimashiKingakuDisp = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : 0
        // elem.warimashiSonotaKingakuDisp = elem.warimashiSonotaKingsku ? filter.numericFormatter(elem.warimashiSonotaKingsku) : 0
        elem.yoshaKihonUnchinDisp = elem.yoshaKihonUnchin ? filter.numericFormatter(elem.yoshaKihonUnchin) : 0
        elem.yoshaHiwayPriceDisp = elem.yoshaHiwayPrice ? filter.numericFormatter(elem.yoshaHiwayPrice) : 0
        elem.yoshaUnchinHokaKingakuDisp = elem.yoshaUnchinHokaKingaku ? filter.numericFormatter(elem.yoshaUnchinHokaKingaku) : 0
        elem.yoshaUnchinHokaHikazeiDisp = elem.yoshaUnchinHokaHikazei ? filter.numericFormatter(elem.yoshaUnchinHokaHikazei) : 0
        // elem.sagyoinTeateKingaku1Disp = elem.sagyoinTeateKingaku1 ? filter.numericFormatter(elem.sagyoinTeateKingaku1) : 0
        // elem.sharyoKeihiHiwayEtcDisp = elem.sharyoKeihiHiwayEtc ? filter.numericFormatter(elem.sharyoKeihiHiwayEtc) : 0
        // elem.sharyoKeihiHiwayGenkinDisp = elem.sharyoKeihiHiwayGenkin ? filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) : 0
        // elem.sharyoKeihiFerryDisp = elem.sharyoKeihiFerry ? filter.numericFormatter(elem.sharyoKeihiFerry) : 0
        // elem.sharyoKeihiEtc1Disp = elem.sharyoKeihiEtc1 ? filter.numericFormatter(elem.sharyoKeihiEtc1) : 0
        elem.uriageKingakuDisp = elem.uriageKingaku ? filter.numericFormatter(elem.uriageKingaku) : 0
        elem.shiharaiYoteiYmdDisp = elem.shiharaiYoteiYmd ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
        // elem.seikyuKingakuGokeiDisp = elem.seikyuKingakuGokei ? filter.numericFormatter(elem.seikyuKingakuGokei) : ''
        // elem.shiharaiKingakuGokeiDisp = elem.shiharaiKingakuGokei ? filter.numericFormatter(elem.shiharaiKingakuGokei) : ''
        // elem.chumonshoReceiveZumiFlgDisp = elem.chumonshoReceiveZumiFlg ? '受領済' : ''
        // elem.chumonkakuninshoSendZumiFlgDisp = elem.chumonkakuninshoSendZumiFlg ? '送付済' : ''
        // elem.hacchushoSendZumiFlgDisp = elem.hacchushoSendZumiFlg ? '送付済' : ''
        // elem.motoukeHokokuZumiFlgDisp = elem.motoukeHokokuZumiFlg ? '報告済' : ''
        return elem
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.unkoJissekiNo > b.unkoJissekiNo) { return 1 }
        if (a.unkoJissekiNo === b.unkoJissekiNo) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return 1 }
        if (a.unkoYmd === b.unkoYmd) { return 0 }
        return -1
      })
    }
  },
  methods: {
    onCustomSearchButtonClick: function (e) {
      this.$set(this.conditions, 'customSearchText', '')
      this.onSearchButtonClick()
    },
    onFilterButtonClick: function (e) {
      this.$set(this.conditions, 'customSearchText', this.tmpCustomSearchText)
    },
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        unkoYoteiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        unkoYoteiEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        haishaEigyoshoId: indexeddb.getRecordByCd(this.currentKaishaCode, this.filteredEigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id,
        jomuinJininId: null,
        tokuisakiId: null,
        ninushiId: null,
        juchuEigyoshoId: null,
        haishaTantoJininId: null,
        sharyoId: null,
        hacchusakiId: null,
        sharyoGroup1: null,
        sharyoGroup2: null,
        jissekiTorokuKbn: '03',
        jissekiKakuninKbn: '03',
        haishaStatusKbn: '03',
        haishasakiKbn: '01',
        meisaiHeadFlg: false,
        customSearchText: ''
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.unkoYoteiStartYmdString.slice(-5) + '～' + initConditions.unkoYoteiEndYmdString.slice(-5),
        haishaEigyoshoNm: indexeddb.getRecord(this.filteredEigyoshoList, initConditions.haishaEigyoshoId).eigyoshoNm,
        tokuisakiNm: '',
        yoshasakiNm: '',
        jomuinJininNm: '',
        jidoshaHyojiNm: '',
        juchuEigyoshoNm: ''
      }
      this.tmpCustomSearchText = ''
      this.searchText = ''
      this.rows = []
      this.page = 1
    }
  }
}
